import { EVENT_ADDON_ITEM_TYPE } from '../../../../constants/event-items';

/**
 * Determines whether the album selection should be tied Waldofied as a single SKU.
 *
 * @param {Array<String>} selectedEventAddonItemTypes List of selected event addon item types.
 * @returns {Boolean}
 */
export const isWaldofiedOnlyPurchase = selectedEventAddonItemTypes => {
  return (
    selectedEventAddonItemTypes.length === 1 &&
    selectedEventAddonItemTypes.includes(EVENT_ADDON_ITEM_TYPE.WALDOFIED)
  );
};

/**
 * Determines whether the album selection should be tied Memory book as a single SKU.
 *
 * @param {Array<String>} selectedEventAddonItemTypes List of selected event addon item types.
 * @returns {Boolean}
 */
export const isMemoryBookOnlyPurchase = selectedEventAddonItemTypes => {
  return (
    selectedEventAddonItemTypes.length === 1 &&
    selectedEventAddonItemTypes.includes(EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK)
  );
};

/**
 * Determines whether the album selection should be tied Group video as a single SKU.
 *
 * @param {Array<String>} selectedEventAddonItemTypes List of selected event addon item types.
 * @returns {Boolean}
 */
export const isGroupVideoOnlyPurchase = selectedEventAddonItemTypes => {
  return (
    selectedEventAddonItemTypes.length === 1 &&
    selectedEventAddonItemTypes.includes(EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO)
  );
};
